// import React from "react";
// import reef_1 from "../assets/images/our_kittens/reef_1.jpg";
// import reef_2 from "../assets/images/our_kittens/reef_2.jpg";
// import coralline_1 from "../assets/images/our_kittens/coralline_1.jpg";
// import coralline_2 from "../assets/images/our_kittens/coralline_2.jpg";
// import saturn_1 from "../assets/images/our_kittens/saturn_1.jpg";
// import saturn_2 from "../assets/images/our_kittens/saturn_2.jpg";
// import pluto_1 from "../assets/images/our_kittens/pluto_1.jpg";
// import pluto_2 from "../assets/images/our_kittens/pluto_2.jpg";

const ourAnimals = [
  // {
  //   src: reef_1,
  //   alt: "Reef",
  //   src2: reef_2,
  //   alt2: "Reef 2",
  //   name: "Reef",
  //   species: "Kitten",
  //   description:
  //     "This boy is a bundle of purring joy. A playful little fluff who just loves love. He has the personality of a golden retriever. Very silly and playful. He may have one brain cell but what’s not to love about that?\nRescued from Los Angeles, CA, Reef is ready to find his forever home.",
  //   age: "8 weeks old",
  //   gender: "Male",
  //   breed: "Orange Shorthair",
  //   location: "San Luis Obispo, CA",
  //   email: "adopt@paddlingpaws.org",
  //   phone: "805-888-9047",
  //   ready_to_go_home: "June 16th, 2025",
  // },
  // {
  //   src: coralline_1,
  //   alt: "Coralline",
  //   src2: coralline_2,
  //   alt2: "Coralline 2",
  //   name: "Coralline",
  //   species: "Kitten",
  //   description:
  //     "A beautiful orange lady with a voice. She will tell it like it is! Coralline is a curious and adventurous girl with lots of energy.\nRescued from Los Angeles, CA, Coralline is ready to find her forever home.",
  //   age: "8 weeks old",
  //   gender: "Female",
  //   breed: "Orange Shorthair",
  //   location: "San Luis Obispo, CA",
  //   email: "adopt@paddlingpaws.org",
  //   phone: "805-888-9047",
  //   ready_to_go_home: "June 16th, 2025",
  // },
  // {
  //   src: saturn_1,
  //   alt: "Saturn",
  //   src2: saturn_2,
  //   alt2: "Saturn 2",
  //   name: "Saturn",
  //   species: "Kitten",
  //   description:
  //     "This girl is an elegant soul. She loves to climb and explore. She can go from a ball of spice to curling up in your arm with soft purrs.\nRescued from a cat colony in North Paso Robles, CA, Saturn is ready to find her forever home.",
  //   age: "8 weeks old",
  //   gender: "Female",
  //   breed: "Tortie Shorthair",
  //   location: "San Luis Obispo, CA",
  //   email: "adopt@paddlingpaws.org",
  //   phone: "805-888-9047",
  //   ready_to_go_home: "June 16th, 2025",
  // },
  // {
  //   src: pluto_1,
  //   alt: "Pluto",
  //   src2: pluto_2,
  //   alt2: "Pluto 2",
  //   name: "Pluto",
  //   species: "Kitten",
  //   description:
  //     "Pluto is the greeter of the bunch! He is the first and last to come for pets and love. His little body holds an abundance of love and joy. Pluto is a lover boy who just wants to be loved and he will love right back!\nRescued from a cat colony in North Paso Robles, CA, Pluto is ready to find his forever home.",
  //   age: "8 weeks old",
  //   gender: "Male",
  //   breed: "Black Shorthair",
  //   location: "San Luis Obispo, CA",
  //   email: "adopt@paddlingpaws.org",
  //   phone: "805-888-9047",
  //   ready_to_go_home: "June 16th, 2025",
  // },
];

// const ourAdoptedAnimals = [
//   // Add more animals here
// ];

function Kittens() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Our Available Kittens</h2>
      <p>
        These kittens are available for adoption through Paddling Paws. <strong>If you
        are interested in adopting one of our kittens, please fill out our
        Kitten Adoption Application below</strong>.
      </p>

      {ourAnimals.length === 0 ? (
         <div
         style={{
           padding: "20px",
           textAlign: "center",
           maxWidth: "1000px",
           margin: "0 auto",
         }}
       >
        <p style={{ marginTop: "1rem" }}>
        💫 We are thrilled to share that all of our kittens are <strong>currently spoken for and have adoption dates scheduled</strong> for the end of June. <strong>Follow us online on Instagram at @paddling.paws or Facebook to stay updated on our future rescues and available kittens!</strong> We are so grateful for your support in helping us find loving homes for our furry friends.
        </p>
        </div>
      ) : (
        <div style={styles.gridContainer}>
          {ourAnimals.map((animal) => (
            <div key={animal.name} style={styles.gridItem}>
              <h3>{animal.name}</h3>
              <p>{animal.species}</p>
              <img src={animal.src} alt={animal.alt} style={styles.image} />
              <p>
                <strong>Gender:</strong> {animal.gender}
              </p>
              <p>
                <strong>Age:</strong> {animal.age}
              </p>
              <p>
                <strong>Breed:</strong> {animal.breed}
              </p>
              <p>
                <strong>Location:</strong> {animal.location}
              </p>
                <p> <strong>Ready to go home:</strong> {animal.ready_to_go_home}</p>
              <img src={animal.src2} alt={animal.alt2} style={styles.image} />
              {animal.description.split("\n").map((line, index) => (
                <p key={index}>{line}</p>
              ))}
              <p>
                <strong>If Interested:</strong>
              </p>
              <p>
                Apply to adopt {animal.name} with our Kitten Adoption
                Application below.
              </p>
            </div>
          ))}
        </div>
      )}
      {/* 
      <h2>Our Adopted Kittens</h2>
      <p>
        These kittens are past Paddling Paws rescues that have since found their
        forever homes. To continue to follow their journey, check out our
        Facebook group,{' '}
        <a
          href="https://www.facebook.com/groups/1291072548697671/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Adopted & Loved
        </a>
        , to see their life after rescue.
      </p>
      <div style={styles.gridContainer}>
        {ourAdoptedAnimals.map((animal) => (
          <div key={animal.name} style={styles.gridItem}>
            {animal.new_name ? (
              <h3>
                Adopted! {animal.name}, now named {animal.new_name}!
              </h3>
            ) : (
              <h3>Adopted! {animal.name}!</h3>
            )}
            <p>Adopted {animal.species}</p>
            <img src={animal.src} alt={animal.alt} style={styles.image} />
            <p>
              <strong>
                Woo hoo! {animal.gender === "Female" ? "She" : "He"} is Adopted!
              </strong>
            </p>
            <p>
              <strong>Gender:</strong> {animal.gender}
            </p>
            <p>
              <strong>Age:</strong> {animal.age}
            </p>
            <p>
              <strong>Breed:</strong> {animal.breed}
            </p>
            <p>
              <strong>Location:</strong> {animal.location}
            </p>
            <img src={animal.src2} alt={animal.alt2} style={styles.image} />
            <p>
              <strong>
                Yay! {animal.gender === "Female" ? "She" : "He"} is Adopted!
              </strong>
            </p>
            {animal.description.split("\n").map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        ))}
      </div> */}
      <div
        style={{
          padding: "20px",
          textAlign: "center",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        <h2>Adopt Your New Best Friend</h2>
        <p>
          It means the world to us that you’re considering adopting a kitten
          from Paddling Paws. Adopting a pet is a life-changing experience—not
          just for you, but for the kitten that finds a loving forever home. 
          <br />
          <strong>NOTE: We require all adopters to agree to never declaw their
          adopted kitten(s)</strong>. Declawing is a painful and unnecessary procedure
          that can lead to long-term physical and behavioral issues for cats. <strong>We also require all adopters agree to keep their adopted kitten(s) as indoor-only pets</strong>. We want all our rescues to have the best chance at a long and healthy life, and keeping them indoors is the best way to protect them from many unnecessary dangers like traffic, predators, and disease.
        </p>
        <h3>Our Kitten Adoption Process</h3>
        <p>
          Our adoption process is designed to ensure that both you and your new
          kitten(s) are set up for success. Here’s what you can expect when you
          adopt from Paddling Paws:
        </p>
        <ul style={{ textAlign: "left" }}>
          <li>
            Fill out the <strong>Adoption Application</strong> below.
          </li>
          <li>
            <strong>Our team will review your application and reach out</strong>{" "}
            to discuss your preferences and answer any questions you may have.
          </li>
          <li>
            We’ll schedule a meet-and-greet ASAP to meet the kitten(s) in their
            foster home. Plan for this being around 30-45 minutes.
          </li>
          <li>
            After the meet-and-greet you will have{" "}
            <strong>24 hours to consider adopting the pet</strong>! During this
            time we will not scheduling any more meet-and-greets for the
            adoptable kitten.
          </li>
          <li>
            If you decide to move forward with the adoption,{" "}
            <strong>
              we’ll schedule a good time within the next week to finalize the
              paperwork and send you home with your new best friend!
            </strong>
          </li>
        </ul>
        <h3>Our Adoption Fee</h3>
        <p>
          Our adoption fee is $150 for one kitten or $200 for a pair. This fee
          helps cover the cost of food, supplies, spaying/neutering,
          vaccinations, and other medical care your pet has received while in
          our care. It also helps us continue our mission of rescuing and
          rehoming animals in need.
        </p>
        <p>
          All kittens are{" "}
          <strong>spayed/neutered, vaccinated, and microchipped</strong> before
          adoption. They are also <strong>dewormed</strong> and{" "}
          <strong>treated for fleas</strong> as needed.
        </p>
        {/* <ul style={{ textAlign: "left" }}>
        <li>.</li>
        <li>
        </li>
        <li>
         
        </li>
        <li>
          
        </li>
        <li>
        </li>
      </ul> */}
        <p>
          Ready to take the next step? Fill out the Adoption Application below,
          and let’s find your new best friend together!
        </p>
      </div>

      {/* Google Form Embed */}
      <h2 style={{ marginTop: "40px", textAlign: "center" }}>
        Adoption Application
      </h2>
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingTop: "150%",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSd8piYkSpfe9XByqMTuiA6EEkBi2T--cgAcb0X1Ebmvck9ylg/viewform?embedded=true"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: 0,
          }}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Kitten Adoption Application"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

const styles = {
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    marginTop: "20px",
  },
  gridItem: {
    flex: "1 1 calc(33.333% - 20px)",
    boxSizing: "border-box",
    margin: "10px",
    padding: "10px",
    border: "3px solid #5180C0",
    borderRadius: "8px",
    maxWidth: "300px",
    minWidth: "200px",
    lineHeight: "1.5em",
  },
  image: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
    marginBottom: "10px",
  },
};

export default Kittens;
